module.exports = __webpack_public_path__ + "img/doc_blue.282ba7c4.svg";